module.exports = __webpack_public_path__ + "img/sc.2b13981f.png";